/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateAssetTypeRequestDto
 */
export interface UpdateAssetTypeRequestDto {
    /**
     * Unique code for the asset type
     * @type {string}
     * @memberof UpdateAssetTypeRequestDto
     */
    code?: string;
    /**
     * Name of the asset type
     * @type {string}
     * @memberof UpdateAssetTypeRequestDto
     */
    name?: string;
    /**
     * Description of the asset type
     * @type {string}
     * @memberof UpdateAssetTypeRequestDto
     */
    description?: string;
    /**
     * JSON schema for metadata validation
     * @type {{ [key: string]: any; }}
     * @memberof UpdateAssetTypeRequestDto
     */
    metadataSchema?: { [key: string]: any; } | null;
}

/**
 * Check if a given object implements the UpdateAssetTypeRequestDto interface.
 */
export function instanceOfUpdateAssetTypeRequestDto(value: object): value is UpdateAssetTypeRequestDto {
    return true;
}

export function UpdateAssetTypeRequestDtoFromJSON(json: any): UpdateAssetTypeRequestDto {
    return UpdateAssetTypeRequestDtoFromJSONTyped(json, false);
}

export function UpdateAssetTypeRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAssetTypeRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'metadataSchema': json['metadataSchema'] == null ? undefined : json['metadataSchema'],
    };
}

export function UpdateAssetTypeRequestDtoToJSON(json: any): UpdateAssetTypeRequestDto {
    return UpdateAssetTypeRequestDtoToJSONTyped(json, false);
}

export function UpdateAssetTypeRequestDtoToJSONTyped(value?: UpdateAssetTypeRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
        'description': value['description'],
        'metadataSchema': value['metadataSchema'],
    };
}

